import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';

import GoogleMapReact from 'google-map-react';

export default class Searchroom extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'1/2568',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          major:'',
          room:'',
          click:false,
          loadding:false,

        };
        this.onChangemajor = this.onChangemajor.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);

      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
      }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }

      getteachingschedule() {

        
        setTimeout(() => {
          this.setState({ loadding:true });
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/showstudentscheduleroom/'+this.state.term+'/'+this.state.room)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ showteachingschedule: res.data})

             if (res.data.length !== 0) {
              const teacher = res.data[0].poname;
              this.setState({ teacher });
              this.setState({ click:true });
              this.setState({ loadding:false });

            }
   
           }) 
         }, 0);
      }


      onChangemajor= e =>{
       console.log(e.target.value);
         // const idemp = value;
          this.setState({ room:e.target.value });

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck: res.data})
        //     }) 
        //   }, 0);

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck2: res.data})
        //     }) 
        //   }, 0);
        //   setTimeout(() => {
        //     this.getteachingschedule()
        //   }, 500);
      }


         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }


    render() {

      const AnyReactComponent = ({ text }) => <div>{text}</div>;
      const defaultProps = {
        center: {
          lat: 16.4534224,
          lng: 99.5114816
        },
        zoom: 11
      };

        const { Option } = Select;
       // let majorname =  this.state.showteachingschedule[0].map(showteachingschedule => { {showteachingschedule.major} }  )     
     //  console.log(this.state.click)
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
      <Card type="inner" className="text-center" title={<h5><MDBIcon icon="list-alt" /> ค้นหาห้องเรียน | ห้องสอน</h5>} >
    <MDBRow>

<MDBCol sm="5">
               
                    {/* <br/> */}

            </MDBCol>
            <MDBCol sm="2">
                <div className="text-center">
                    {/* <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />    */}
                    <div className="text-left"><label ><strong>ปีการศึกษา</strong></label></div> 
                        <Select
                            showSearch
                             style={{ width: "calc(100% - 0px)" }} 
                          //  style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            value={this.state.term}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            className="text-left"
                        >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564" >1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                            <Option value="1/2565">1/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option value="2/2566">2/2566</Option>
                            <Option ative value="3/2566">3/2566</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option value="2/2567">2/2567</Option>
                            <Option ative value="3/2567">3/2567</Option>
                            <Option value="1/2568">1/2568</Option>
                            <Option value="2/2568">2/2568</Option>
                            <Option value="3/2568">3/2568</Option>
                            <Option value="1/2569">1/2569</Option>
                            <Option value="2/2569">2/2569</Option>
                            <Option value="3/2569">3/2569</Option>
                            

                        </Select>
                    </div>
                    {/* <br/> */}

                    <div className="text-center">

                        {/* <UserOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />    */}
                        <div className="text-left"><label className="text-left mt-2"><strong>ห้องเรียน เช่น 14501</strong></label></div> 
                        <Input placeholder="ห้องเรียน เช่น 14501"   style={{ width: "calc(100% - 0px)" }}   onChange={this.onChangemajor} />
                        {/* <Button type="primary"  onClick={this.getteachingschedule} >ค้นหา</Button> */}
                       </div>
                     
                        <br/>
                        { this.state.term !== "" && this.state.room !== "" ?<> 
                        <div className="text-center">
                        <Button type="primary"  onClick={this.getteachingschedule} >ค้นหา</Button>
                        </div></>:<>  
                                  { this.state.term === "" ?<> </>:<>  
                                  <div className="text-center">
                                  <Button type="primary" disabled  >ค้นหา</Button>
                                  </div>  </> }    
                    
             </> }
            </MDBCol>

            <MDBCol sm="5">
          {/* { this.state.term === "" ?<> </>:<> 
         
          </> } */}
                       {/* <div>
                        <UserOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Input placeholder="ห้องเรียน เช่น 14501"  style={{ width: 300 }}  onChange={this.onChangemajor} />
                       </div>
                        <br/> */}
            </MDBCol>
            {/* <MDBCol sm="2">
            { this.state.term !== "" && this.state.room !== "" ?<> 
            <div className="text-left">
            <Button type="primary"  onClick={this.getteachingschedule} >ค้นหา</Button>
            </div></>:<>  
                      { this.state.term === "" ?<> </>:<>  
                      <div className="text-left">
                      <Button type="primary" disabled  >ค้นหา</Button>
                      </div>  </> }    
                    
             </> }
            
            </MDBCol> */}
  </MDBRow>

                {/* { this.state.empcouncilcheck.length === 0 ? <> </> : 
                <>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันอังคาร ของทุกเดือน
                </MDBAlert>
                </>}


                { this.state.empcouncilcheck2.length === 0 ? <> </> : 
                <>
                <MDBAlert color="warning ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันพฤหัสบดี ของทุกเดือน
                </MDBAlert>
                </>} */}

          { this.state.term === '' ? <></> :<> 
          <br/>
          <hr/>
         
              {/* <MDBAlert color="success">
              <h5 className="text-center">ตารางการใช้ห้อง</h5> 
              <h5 className="text-center">ภาคเรียนที่ {this.state.term}</h5> 
              {this.state.click === true ?<><h5 className="text-center">ห้องเรียน {this.state.room }</h5> </>:<></>}
             </MDBAlert> */}

             <h5 className="text-center">ตารางการใช้ห้อง ปีการศึกษา {this.state.term}</h5> 
             {this.state.click === true ?<><h5 className="text-center">ห้องเรียน {this.state.room }</h5> </>:<></>}


              {/* <h5>{this.majorname}</h5> */}
           {/* {this.state.teacher === ''?<></>:<>  <h5 className="text-center">อาจารย์{this.state.teacher} </h5> </> } */}
          
          {this.state.loadding === true ? <>
          <div className="spinner-grow text-primary text-center" role="status">
              <span className="sr-only text-center">Loading...</span>
            </div>
            </>: <>
            <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1">
                <tr>
                    {/* <th  className="text-center">ลำดับ</th> */}
                    <th  className="text-center">หมู่เรียน</th>
                    <th  className="text-center">โปรแกรม</th>
                    <th  className="text-center">รหัสวิชา</th>
                    <th  className="text-center">ชื่อวิชา</th>
                    <th  className="text-center">ผู้สอน</th>
                    <th  className="text-center">จำนวน</th>
                    {/* <th  className="text-center">กลุ่ม</th> */}
                    <th  className="text-center">วัน</th>
                    <th  className="text-center">เวลา</th>
                    <th  className="text-center">ห้องเรียน</th>
                </tr>
              
                </MDBTableHead>

             

                <MDBTableBody>
                {this.state.showteachingschedule.map((showteachingschedule,index) => {
                
                   //กศบป
                    const  time2 = Number (showteachingschedule.hour1*55)
                    const  ddf = time2-5
                    const  now = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                    const totalsss = now.setMinutes(now.getMinutes()+ddf);
                    const wanwela = new Date(totalsss)
                    const wanwela1 =  wanwela.toLocaleTimeString()

                    //ปกติ
                    const  timenormal = Number (showteachingschedule.hour1*60)
                    const  now2 = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                    const totalsss2 = now2.setMinutes(now2.getMinutes()+timenormal);
                    const wanwela2 = new Date(totalsss2)
                    const normal =  wanwela2.toLocaleTimeString()
                       
                     return   <tr>
                          {/* <td  className="text-center">{index+1}</td> */}
                          <td  className="text-center">{showteachingschedule.id_major}</td>
                          <td  className="text-left">{showteachingschedule.t_mjnamecheck}</td>
                          <td  className="text-center">{showteachingschedule.SUBJCODE.substring(0,7)}</td>
                          <td className="text-left">{showteachingschedule.SUBJNAME}</td>
                          <td className="text-left">{showteachingschedule.prenm}{showteachingschedule.poname}</td>
                          <td  className="text-center">{showteachingschedule.numregister}</td>
                          {/* <td> <p><Modalcolor idcolor={teachingschedule.group_id} /></p></td> */}
                          {/* <td>อาจารย์{teachingschedule.poname}</td> */}

                          {/* ช่วงที่1 */}
                          <td  className="text-center"> {showteachingschedule.ss === '1' ?<> จันทร์</>:<></> }
                               {showteachingschedule.ss === '2' ?<> อังคาร</>:<></> }
                               {showteachingschedule.ss === '3' ?<> พุธ</>:<></> }
                               {showteachingschedule.ss === '4' ?<> พฤหัสบดี</>:<></> }
                               {showteachingschedule.ss === '5' ?<> ศุกร์</>:<></> }
                               {showteachingschedule.ss === '6' ?<> เสาร์</>:<></> }
                               {showteachingschedule.ss === '7' ?<> อาทิตย์</>:<></> }
                          </td>
                          <td>
                          {showteachingschedule.times1 === null || showteachingschedule.times1 === ''  ? <></> :<>
                              {showteachingschedule.day === 'weekly2' ?<>{showteachingschedule.times2} - {showteachingschedule.timesend2}</>:<>{showteachingschedule.times1} - {showteachingschedule.timesend1}</>}
                              {/* { showteachingschedule.id_major.substring(2, 3) === '1' ?<>{normal.substring(0, 5)} </> :<>{wanwela1.substring(0, 5)}  </>} */}
                                </> }
                          </td>
                          <td  className="text-center">{showteachingschedule.classroom1}</td>
                          </tr>
                  
                })}   
                </MDBTableBody>
            </MDBTable>
            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1704.4892452269887!2d99.51167655905925!3d16.45279351979246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30de18fa08dff6c3%3A0x89cb831117f00788!2z4Lio4Li54LiZ4Lii4LmM4Lig4Liy4Lip4Liy4LmB4Lil4Liw4LiE4Lit4Lih4Lie4Li04Lin4LmA4LiV4Lit4Lij4LmM4Lih4Lir4Liy4Lin4Li04LiX4Lii4Liy4Lil4Lix4Lii4Lij4Liy4LiK4Lig4Lix4LiP4LiB4Liz4LmB4Lie4LiH4LmA4Lie4LiK4Lij!5e0!3m2!1sth!2sth!4v1676532608744!5m2!1sth!2sth" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
        </>}
           {/* <div className="spinner-grow text-primary text-center" role="status">
              <span className="sr-only text-center">Loading...</span>
            </div> */}

        {/* 
         <div style={{ height: '100vh', width: '100%' }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: "" }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
          >
            <AnyReactComponent
              lat={16.4534224}
              lng={99.5114816}
              text="My Marker"
            />
          </GoogleMapReact>
         </div> */}
 
 

        </Card>
            </MDBContainer>
        )
    }
}
